<template lang="pug">
  .d-flex.flex-column
    v-row(
      v-for="(criterian, idx) in criteria"
      :key="criterian.id"
    )
      v-col(cols="12")
        criteria-card(
          :value="criterian"
          :hide-actions="criteria.length <= 1"
          @delete="() => deleteCriterian(idx)"
          @input="(val) => updateCriterian(idx, val)"
        )

    v-row
      v-col.py-2(
        v-if="maxSumCriteriaScore"
        cols="12"
      )
        dv-alert.px-0.py-0(
          text
          no-tonal
          type="info"
          color="ui-primary"
        )
          span За этот вопрос можно получить максимум {{ maxSumCriteriaScore }} баллов

    v-row
      v-col(cols="12")
        dv-input(
          v-model="criteria"
          v-bind="$attrs"
          hide-details="auto"
        )
          .d-flex.mb-2
            dv-btn(
              large
              color="ui-primary lighten-4"
              @click="() => addCriterian()"
            )
              v-icon.mr-2(size="20" color="ui-primary") $ui-plus
              p.ui-primary--text Добавить критерий
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';
import DvAlert from '@/packages/ui/components/alerts/DvAlert.vue';
import DvInput from '@/packages/ui/components/inputs/DvInput.vue';
import CriteriaCard from '../cards/CriteriaCard.vue';

import Criterian from '@/models/list/criterian/index.js';

export default {
  components: {
    DvBtn,
    DvAlert,
    DvInput,
    CriteriaCard,
  },
  props: {
    value: {
      type: Array,
      default: undefined,
    },
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  data() {
    return {
      criteria: this.value,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.criteria = val;

        if (!val?.length) this.addCriterian();
      },
      immediate: true,
    },
    criteria(val) {
      this.$emit('input', val);
    },
  },
  computed: {
    maxSumCriteriaScore() {
      return this.criteria
        .reduce((acc, i) => (
          acc + (i.max_score || 0)
        ), 0);
    },
  },
  methods: {
    addCriterian() {
      const { criteria } = this;

      if (!Array.isArray(criteria)) {
        this.criteria = [];
      }

      const newCriteria = new Criterian({}, 'criterian');

      this.criteria.push(newCriteria);
    },
    updateCriterian(idx, val) {
      const { criteria } = this;
      this.$set(criteria, idx, val);
    },
    deleteCriterian(idx) {
      this.criteria.splice(idx, 1);
    },
  },
};
</script>
